import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../app_state';

@Component({
  selector: 'yi-widget-preview',
  template: require('./widget_preview.component.html'),
  styles: [ require('../../../install.utils.scss'), require('./widget_preview.component.scss')]
})
export class WidgetPreviewComponent {
  public widgetState;
  constructor(public store: Store<IAppState>) {
    this.widgetState = this.store.select(state => state.app.install.widget);
  }
}
